/**
 * 数字格式化工具
 */

/**
 * 格式化数字，保留指定小数位
 * @param {number|string} value - 要格式化的数字
 * @param {number} decimals - 小数位数，默认8
 * @returns {string} 格式化后的字符串
 */
export const formatNumber = (value, decimals = 8) => {
  if (value === null || value === undefined || value === '') {
    return '0';
  }
  
  const num = typeof value === 'string' ? parseFloat(value) : value;
  
  if (isNaN(num)) {
    return '0';
  }
  
  // 如果数字很大，使用科学计数法
  if (Math.abs(num) >= 1e15) {
    return num.toExponential(decimals);
  }
  
  return num.toFixed(decimals).replace(/\.?0+$/, '');
};

/**
 * 格式化货币（USDT等）
 * @param {number|string} value - 金额
 * @param {number} decimals - 小数位数，默认2
 * @returns {string} 格式化后的字符串
 */
export const formatCurrency = (value, decimals = 2) => {
  return formatNumber(value, decimals);
};

/**
 * 格式化资产数量（挖矿资产等）
 * @param {number|string} value - 数量
 * @param {number} decimals - 小数位数，默认8
 * @returns {string} 格式化后的字符串
 */
export const formatAsset = (value, decimals = 8) => {
  return formatNumber(value, decimals);
};

/**
 * 格式化百分比
 * @param {number|string} value - 百分比值（0-100）
 * @param {number} decimals - 小数位数，默认2
 * @returns {string} 格式化后的字符串，带%符号
 */
export const formatPercent = (value, decimals = 2) => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) {
    return '0%';
  }
  return `${formatNumber(num, decimals)}%`;
};

/**
 * 格式化大数字（添加千分位）
 * @param {number|string} value - 数字
 * @param {number} decimals - 小数位数
 * @returns {string} 格式化后的字符串
 */
export const formatLargeNumber = (value, decimals = 2) => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) {
    return '0';
  }
  
  const formatted = num.toFixed(decimals);
  const parts = formatted.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

